/** Thin wrapper so tests can mock reload without stubbing jsdom's `window.location`. */
export default function reloadPage(): void {
  window.location.reload()
}
